import { render, staticRenderFns } from "./k-actions-icons.vue?vue&type=template&id=2bd1fd10&lang=pug&"
import script from "./k-actions-icons.vue?vue&type=script&lang=js&"
export * from "./k-actions-icons.vue?vue&type=script&lang=js&"
import style0 from "./k-actions-icons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bd1fd10')) {
      api.createRecord('2bd1fd10', component.options)
    } else {
      api.reload('2bd1fd10', component.options)
    }
    module.hot.accept("./k-actions-icons.vue?vue&type=template&id=2bd1fd10&lang=pug&", function () {
      api.rerender('2bd1fd10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-actions-icons.vue"
export default component.exports